(function () {
  'use strict';

  var LAZY_ATTR = 'data-mc-src';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function promoteImage(cell) {
    var img = cell.querySelector('img[' + LAZY_ATTR + ']');
    if (!img) return;

    var src = img.getAttribute(LAZY_ATTR);
    img.setAttribute('data-src', src);
    img.removeAttribute(LAZY_ATTR);
    img.classList.add('lazyloadt4s');

    if (window.lazySizesT4 && window.lazySizesT4.loader) {
      window.lazySizesT4.loader.checkElems();
    }
  }

  function setActiveCell(container, cells, dots, cell) {
    if (!cell) return;

    promoteImage(cell);

    var index = cell.getAttribute('data-mc-index');

    for (var i = 0; i < cells.length; i++) {
      cells[i].classList.toggle('is--active', cells[i] === cell);
    }

    var activePos = -1;
    for (var d = 0; d < dots.length; d++) {
      var on = dots[d].getAttribute('data-mc-index') === index;
      dots[d].classList.toggle('is--active', on);
      if (on) activePos = d;
    }

    if (dots.length && dots[0].parentNode) {
      var box = dots[0].parentNode;
      box.style.setProperty('--mc-total', dots.length);
      if (activePos >= 0) box.style.setProperty('--mc-idx', activePos);
    }
  }

  function currentIndex(cells) {
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].classList.contains('is--active')) return i;
    }
    return 0;
  }

  function scrollToIndex(track, cells, dots, container, index) {
    var count = cells.length;
    var wrapped = ((index % count) + count) % count;
    var target = cells[wrapped];
    if (!target) return;

    track.scrollTo({
      left: target.offsetLeft - track.offsetLeft,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });

    setActiveCell(container, cells, dots, target);
  }

  function initOne(container) {
    if (container.hasAttribute('data-mc-slider-ready')) return;
    container.setAttribute('data-mc-slider-ready', 'true');

    if (container.closest('.t4s_box_pr_slider')) {
      container.setAttribute('data-mc-single', 'true');

      var singleCells = container.querySelectorAll('[data-mc-slider-cell]');
      if (singleCells[0]) promoteImage(singleCells[0]);
      if (singleCells[1]) promoteImage(singleCells[1]);
      return;
    }

    var track = container.querySelector('[data-mc-slider-track]');
    if (!track) return;

    var cells = track.querySelectorAll('[data-mc-slider-cell]');

    var dotScope = container.closest('.t4s-product-wrapper') || container.parentNode || container;
    var dots = dotScope.querySelectorAll('[data-mc-slider-dot]');
    if (!cells.length) return;

    setActiveCell(container, cells, dots, cells[0]);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              setActiveCell(container, cells, dots, entry.target);
            }
          });
        },
        { root: track, threshold: [0, 0.6, 1] },
      );

      for (var i = 0; i < cells.length; i++) {
        observer.observe(cells[i]);
      }
    }

    var prevBtn = container.querySelector('[data-mc-slider-prev]');
    var nextBtn = container.querySelector('[data-mc-slider-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToIndex(track, cells, dots, container, currentIndex(cells) - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToIndex(track, cells, dots, container, currentIndex(cells) + 1);
      });
    }

    for (var j = 0; j < dots.length; j++) {
      dots[j].addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var index = parseInt(event.currentTarget.getAttribute('data-mc-index'), 10);
        scrollToIndex(track, cells, dots, container, index);
      });
    }

    track.addEventListener('click', function (event) {
      var wasDragged = track.dataset.mcDragged === 'true';
      track.dataset.mcDragged = 'false';
      if (wasDragged) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var productInner = container.closest('.t4s-product-inner');
      var link =
        productInner && productInner.querySelector(':scope > .t4s-full-width-link[data-pr-href]');
      var href = link && link.getAttribute('href');
      if (href) {
        window.location.href = href;
      }
    });

    var dragStartX = null;
    track.addEventListener(
      'pointerdown',
      function (event) {
        dragStartX = event.clientX;
        track.dataset.mcDragged = 'false';
      },
      { passive: true },
    );
    track.addEventListener(
      'pointermove',
      function (event) {
        if (dragStartX === null) return;
        if (Math.abs(event.clientX - dragStartX) > 8) {
          track.dataset.mcDragged = 'true';
        }
      },
      { passive: true },
    );
  }

  window.mcInitCardSliders = function mcInitCardSliders() {
    var containers = document.querySelectorAll(
      '.mc-card-slider[data-mc-slider]:not([data-mc-slider-ready])',
    );
    for (var i = 0; i < containers.length; i++) {
      initOne(containers[i]);
    }
  };

  function installReinitHook() {
    window.T4SThemeSP = window.T4SThemeSP || {};
    var previous = window.T4SThemeSP.reinitProductGridItem;

    if (previous && previous.__mcWrapped) return;

    var wrapped = function () {
      if (typeof previous === 'function') {
        previous.apply(this, arguments);
      }
      window.mcInitCardSliders();
    };
    wrapped.__mcWrapped = true;

    window.T4SThemeSP.reinitProductGridItem = wrapped;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    installReinitHook();
    window.mcInitCardSliders();

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (
              node.matches &&
              (node.matches('.mc-card-slider') || node.querySelector('.mc-card-slider'))
            ) {
              window.mcInitCardSliders();
              return;
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
